/**
 * Return version YYYY.MM.DD-GH_RUN_NUMBER.GH_RUN_ATTEMPT.
 * Function works in main process as well as in renderer- and node processes.
 */
export const getClientVersion = () => BC_VERSION;
